export const isVisible = ele => {
  const boundary = ele.getBoundingClientRect();
  return (
    boundary.top >= 0 &&
    boundary.left >= 0 &&
    boundary.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    boundary.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const createMarkup = content => {
  return { __html: content };
};
